class DropDownOffices {
	constructor() {
		this.dropdownContent = document.getElementById('dropdown-content');
		this.dropdownTitle = document.getElementById('offices-section-title');
		this.lineVerticalBtnMoreOffice = document.getElementById('vertical-line');
		this.officesContent = document.getElementById('offices-content');

        if (
            this.dropdownContent && 
            this.dropdownTitle && 
            this.lineVerticalBtnMoreOffice && 
            this.officesContent
        ) {
			this.init();
		}
	}

	init() {
		this.dropdownTitle.addEventListener('click', () => {
			this.dropdownContent.classList.toggle('active');
			this.lineVerticalBtnMoreOffice.classList.toggle('hide');
			//this.officesContent.classList.toggle('pd-bottom');
		});
	}
}

export default DropDownOffices;
